import delivery_store from './delivery';
import document_store from './document';
import report_store from './report';
import app_store from './app';
import vehicle_store from './vehicle';
import dashboard_store from './dashboard';

const stores = {
    app_store,
    delivery_store,
    document_store,
    dashboard_store,
    report_store,
    vehicle_store
};

export default stores;



// WEBPACK FOOTER //
// ./src/stores/index.js